export default __webpack_public_path__ + "static/media/book-service.fbede0d3.svg";